/**
 * 口コミ検索フォームアクションを登録する
 */
function registReviewSearchFormAction() {

	//都道府県プルダウン選択時のイベント
	$('.js-review-search-form [name=pref]').change(function () {
		//市区町村プルダウンの選択を初期化
		$('.js-review-search-form [name=city] option').remove();
		$('.js-review-search-form [name=city] optgroup').remove();
		$('.js-review-search-form [name=city]').append(
			$('<option>').html('市区町村を選択').val('')
		);

		//教室プルダウンの選択を初期化
		$('.js-review-search-form [name=kousha] option').remove();
		$('.js-review-search-form [name=kousha]').append(
			$('<option>').html('教室を選択').val('')
		);

		//ajaxで市区町村リスト取得
		$.ajax({
			type: 'POST',
			url:
				'/kb_review/get_city_list/' +
				$('.js-review-search-form [name=pref]').val() +
				'/' +
				$('#juku_id').attr('value'),
			data: { is_json: 1 },
		}).done(function (res) {
			for (var i in res.list) {
				//市区町村項目を追加
				$('.js-review-search-form [name=city]').append(
					$('<option id="' + res.list[i].l_place_name + '">')
						.html(res.list[i].s_place_name)
						.val(res.list[i].s_place_cd)
				);
				//市区町村に紐づくl_place_nameが次の配列と一致しなければそれまでのoptionタグをoptgroupタグでくくる
				if (
					!res.list[parseInt(i) + 1] ||
					res.list[i].l_place_name !=
						res.list[parseInt(i) + 1].l_place_name
				) {
					$('#' + res.list[i].l_place_name).wrapAll(
						'<optgroup label="' + res.list[i].l_place_name + '">'
					);
				}
			}
		});
	});

	//市区町村プルダウン選択時のイベント
	$('.js-review-search-form [name=city]').change(function () {
		//市区町村プルダウンの選択を初期化
		$('.js-review-search-form [name=kousha] option').remove();
		$('.js-review-search-form [name=kousha]').append(
			$('<option>').html('教室を選択').val('')
		);

		//ajaxで市区町村リスト取得
		$.ajax({
			type: 'POST',
			url:
				'/kb_review/get_kousha_list/' +
                $('.js-review-search-form [name=pref]').val() +
                '/' + $('.js-review-search-form [name=city]').val() +
                '/' + $('#juku_id').attr('value'),
			data: { is_json: 1 },
		}).done(function (res) {
			for (var i in res.list) {
				//市区町村項目を追加
				$('.js-review-search-form [name=kousha]').append(
					$('<option id="' + res.list[i].kousha_id + '">')
						.html(res.list[i].kousha_name)
						.val(res.list[i].kousha_id)
				);
			}
		});
	});

	//フォームサブミットイベント追加
	$('.js-review-search-form').submit(function (e) {
		// 都道府県の取得
		var pref = $('.js-review-search-form [name=pref]').val();

		// 市区町村の取得
		var city = $('.js-review-search-form [name=city]').val();

		// 教室の取得
		var kousha = $('.js-review-search-form [name=kousha]').val();

		var paramArr = new Array();
		kousha != null && kousha.length != 0 && kousha != '' ? paramArr.push('kousha_id=k' + kousha) : '';
		pref != null && pref.length != 0 && pref != '' ? paramArr.push('pref_cd=p' + pref) : '';
		city != null && city.length != 0 && city != '' ? city.length == 3 ? paramArr.push('l_place_cd=c' + city) : paramArr.push('s_place_cd=c' + city) : '';

		var param = paramArr.join('&');
		if (param != '') {
			param = '?' + param;
		} else {
			param = '?locate=top';
		}

		//submit用URL作成
		var url = location.href.split('?')[0];
		url = url + param;
		$(location).attr('href', url);
		return false;
	});

	// 絞り込み領域アコーディオン
	$('.js-review-condition-accordion').on('click', function () {
		if ($(this).is('.js-review-condition-accordion-open')) {
			$(this).children().html('絞込む');
			$(this).removeClass('js-review-condition-accordion-open');
		} else {
			$(this).children().html('閉じる');
			$(this).addClass('js-review-condition-accordion-open');
		}
		$(this).next().slideToggle();
	});
}

/**
 * ページロード後に処理を走らせる
 */
$(function () {
	registReviewSearchFormAction();
});
